import { TfiAnnouncement, TfiClose } from "react-icons/tfi";
import moment from "moment";
import { cn } from "../../helpers/cn";
import useGetMaintanceAnnouncement from "./useGetMaintanceAnnouncement";
import useLocalStorage from "../../hooks/useLocalStorage";
import { localStorageVariables } from "../../constants";

const activePeriodCheck = (startTime, endTime) => {
  const now = moment();

  const hasValidDates = Boolean(startTime && endTime);

  return hasValidDates && now.isBetween(moment(startTime), moment(endTime));
};

function parseTextToElements(text) {
  if (typeof text !== "string") {
    return "";
  }

  const regex = /(\*\*.*?\*\*|__.*?__|_.*?_|~~.*?~~)/g;
  const parts = text.split(regex);

  return parts.map((part, i) => {
    if (part.startsWith("**") && part.endsWith("**")) {
      return <b key={i}>{part.slice(2, -2)}</b>;
    } else if (part.startsWith("_") && part.endsWith("_")) {
      return <i key={i}>{part.slice(1, -1)}</i>;
    } else if (part.startsWith("__") && part.endsWith("__")) {
      return <u key={i}>{part.slice(2, -2)}</u>;
    } else if (part.startsWith("~~") && part.endsWith("~~")) {
      return <del key={i}>{part.slice(2, -2)}</del>;
    }
    return <span key={i}>{part}</span>;
  });
}

function Announcement() {
  const { data: response, isLoading, isError } = useGetMaintanceAnnouncement();

  const hasMessage = Boolean(response?.data?.message);
  const isWithinActiveTimeframe = activePeriodCheck(
    response?.data?.startTime,
    response?.data?.endTime
  );

  const [lastClosedAnnouncementBanner, setLastClosedAnnouncementBanner] =
    useLocalStorage({
      key: localStorageVariables.lastClosedAnnouncementBanner,
      initialValue: null,
    });

  const currentAnnouncementBannerClosed =
    response?.data?.id === lastClosedAnnouncementBanner;

  const handleCloseAnnouncementBanner = () => {
    setLastClosedAnnouncementBanner(response?.data?.id);
  };

  const isAnnouncmentActive =
    !isLoading &&
    !isError &&
    hasMessage &&
    isWithinActiveTimeframe &&
    !currentAnnouncementBannerClosed;

  return (
    <div
      className={cn(
        "tw-flex tw-items-center tw-bg-[#195483] tw-text-white tw-overflow-hidden tw-transition-all ",
        isAnnouncmentActive
          ? "tw:opacity-100 tw-px-4 tw-py-3 tw-border-b-2"
          : "tw-max-h-0 tw-opacity-0 tw-p-0"
      )}
      role="alert"
    >
      {isAnnouncmentActive && (
        <>
          <TfiAnnouncement
            className="tw-text-2xl tw-mr-5"
            style={{ minWidth: "1.4rem" }}
          />
          <div>{parseTextToElements(response?.data?.message)}</div>
          <TfiClose
            role="button"
            onClick={handleCloseAnnouncementBanner}
            className="tw-text-2xl tw-ml-5 tw-cursor-pointer no-copy"
            style={{ minWidth: "1.2rem" }}
          />
        </>
      )}
    </div>
  );
}

export default Announcement;
